import sum from 'root-core/utils/array/sum.js'
import Hotels from '../accommodation/hotels/index.js'
import * as roomOccupancy from '../accommodation/roomOccupancy.js'
import buildPartyForAllocation from '../buildPartyForAllocation.js'

export default (priceOptions, departure, passengers, features) => {
  if (priceOptions.rooms) {
    const party = {
      adults: sum(priceOptions.rooms.map(roomOccupancy.numberOfAdultsInRoom)),
      children: sum(
        priceOptions.rooms.map(roomOccupancy.numberOfChildrenInRoom)
      ),
    }
    const partyForAllocation = buildPartyForAllocation({
      party,
      passengers,
      features,
      departureStartDate: departure.startDate,
    })

    const extraStays = {}
    if (priceOptions.hotelBefore && priceOptions.hotelBefore.hotelId) {
      let hotelsBefore = new Hotels({
        departure,
        beforeAfter: 'before',
        features,
      })
      hotelsBefore.setUrlParams(priceOptions.hotelBefore)
      hotelsBefore.setParty(party, partyForAllocation)
      hotelsBefore.hotelsNowHaveAvailabilities()

      const hotelBefore = hotelsBefore.selectedHotel()
      if (hotelBefore) {
        const selectedRoomAllocation = hotelBefore.selectedRoomAllocation()
        extraStays.before = {
          selectedHotel: hotelBefore,
          selectedHotelRooms: hotelsBefore.roomAllocation, // TODO should be hotelsBefore.selectedRoomAllocation?
          nights: priceOptions.hotelBefore.nights,
          total: selectedRoomAllocation ? selectedRoomAllocation.price : 0,
        }
      }
    }

    if (priceOptions.hotelAfter && priceOptions.hotelAfter.hotelId) {
      const hotelsAfter = new Hotels({
        departure: departure,
        beforeAfter: 'after',
        features,
      })
      hotelsAfter.setUrlParams(priceOptions.hotelAfter)
      hotelsAfter.setParty(party, partyForAllocation)
      hotelsAfter.hotelsNowHaveAvailabilities()

      const hotelAfter = hotelsAfter.selectedHotel()

      if (hotelAfter) {
        const selectedRoomAllocation = hotelAfter.selectedRoomAllocation()
        extraStays.after = {
          selectedHotel: hotelAfter,
          selectedHotelRooms: hotelsAfter.roomAllocation, // TODO should be hotelsAfter.selectedRoomAllocation?
          nights: priceOptions.hotelAfter.nights,
          total: selectedRoomAllocation ? selectedRoomAllocation.price : 0,
        }
      }
    }
    return extraStays
  }
}
